import PropTypes from 'prop-types'

const OneColumnLoginPage = ({ placeholders: { loginMainContent } = {}}) => loginMainContent

OneColumnLoginPage.propTypes = {
  placeholders: PropTypes.shape({
    loginMainContent: PropTypes.array
  })
}

OneColumnLoginPage.type = 'OneColumnDesktopLoginPage'
OneColumnLoginPage.placeholders = ['loginMainContent']

export default OneColumnLoginPage
